import SendGuideModule from './SendGuide.module';

export default SendGuideModule;
